<template>
  <div class="helpbox__content">
    <div class="attention-icon">
      <img src="../assets/icons/attention-icon.svg" alt="" />
    </div>
    <p class="title text note" :style="{ 'margin-bottom': '20px' }">
      <span class="make-bold">Hast du Fragen?</span>
      <br />
      Falls du Fragen hast, sind wir gerne für dich da!
    </p>

    <div class="helpbox-item" @click="handleCallButton">
      <div class="helpbox-item__icon">
        <img src="../assets/icons/phone.svg" alt="" />
      </div>
      <div class="helpbox-item__content text note">
        <div class="heading make-bold">+49 (0)211 - 9462 55-5</div>
        <div class="description">Mo-Fr 8:30-17:00 Uhr</div>
      </div>
    </div>

    <div class="helpbox-item" @click="handelEmailButton">
      <div class="helpbox-item__icon">
        <img src="../assets/icons/email.svg" alt="" />
      </div>
      <div class="helpbox-item__content text note">
        <div class="heading make-bold">E-Mail</div>
        <div class="description">Sende uns eine Nachricht</div>
      </div>
    </div>

    <div class="helpbox-item" @click="handleFAQButton">
      <div class="helpbox-item__icon">
        <img src="../assets/icons/question.svg" alt="" />
      </div>
      <div class="helpbox-item__content text note">
        <div class="heading make-bold">FAQ</div>
        <div class="description">Häufig gestellte Fragen</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelpboxContent",
  props: ['onClose'],
  methods: {
    handleCallButton: () => (window.location.href = "tel:+4902119462555"),
    handelEmailButton: () =>
      (window.location.href = "mailto:fahrzeugankauf@pkw.de"),
    handleFAQButton () {
      
      // We are duplicating it here, to have an updated value after every click
      const isMobileScreen = window.innerWidth <= 2150;
      if (isMobileScreen) {
        this.onClose();
      }
      document
        .querySelector(".faq-section")
        .scrollIntoView({ behavior: "smooth" });
    },
    
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/landing-components/HelpboxContent.vue